// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

//   React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

//   React context
import {useMaterialUIController} from "context";
import {Grid, Typography} from "@mui/material";
import properties from "constants/ApplicationConstants";
function Bill_address({details = {}, noGutter}) {
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;

  return (
    <MDBox pt={1} pb={0} px={2}>
      <MDBox pt={3} px={2}>
        <Typography variant="h6" fontWeight="medium" fontFamily={properties.fontFamily}>
          Address
        </Typography>
      </MDBox>

      <MDBox
        component="li"
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        bgColor={darkMode ? "transparent" : "grey-100"}
        borderRadius="lg"
        p={1}
        mb={noGutter ? 0 : 1}
        mt={1}
      >
        <MDBox width="100%" display="flex" flexDirection="column">
          <Grid container spacing={2} mb={2}>
            <Grid item xs={12} sm={6}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <Typography variant="caption" color="text" fontFamily={properties.fontFamily}>
                  Present Address :&nbsp;
                </Typography>
              </MDBox>
            </Grid>

            <Grid item xs={12} sm={6}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <Typography
                  variant="caption"
                  color="text"
                  mr={40}
                  fontFamily={properties.fontFamily}
                >
                  Permanent Address :&nbsp;
                </Typography>
              </MDBox>
            </Grid>
          </Grid>
          <MDBox
            display="flex"
            // key={index}
            justifyContent="space-between"
            alignItems={{xs: "flex-start", sm: "center"}}
            flexDirection={{xs: "column", sm: "row"}}
            mb={1}
          >
            <Grid item xs={12} sm={6}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  fontFamily={properties.fontFamily}
                  textTransform="capitalize"
                  mr={2}
                >
                  {details
                    ? details.presentAddressLine1 +
                      " " +
                      details.presentAddressLine2 +
                      " " +
                      details.presentAddressLine3 +
                      " " +
                      details.presentCity +
                      " " +
                      details.presentState +
                      " " +
                      details.presentPincode
                    : "NA"}
                </Typography>
              </MDBox>
            </Grid>
            <Grid item xs={12} sm={6}>
              <MDBox display="flex" alignItems="center" gap={1}>
                <Typography
                  variant="caption"
                  fontWeight="medium"
                  textTransform="capitalize"
                  fontFamily={properties.fontFamily}
                >
                  {details
                    ? details.permanentAddressLine1 +
                      " " +
                      details.permanentAddressLine2 +
                      " " +
                      details.permanentAddressLine3 +
                      " " +
                      details.permanentCity +
                      " " +
                      details.permanentState +
                      " " +
                      details.permanentPincode
                    : "NA"}
                </Typography>
              </MDBox>
            </Grid>
          </MDBox>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

Bill_address.defaultProps = {
  noGutter: false
};

Bill_address.propTypes = {
  name: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  vat: PropTypes.string.isRequired,
  noGutter: PropTypes.bool
};

export default Bill_address;
